import React from "react";
import './../style/privacypolicy.css';
import { Link } from "react-router-dom";

function Privacypolicy() {
  return (
    <>
    <section className="privacypolicysection">
        <div className="privacypolicydiv">
        <h1>
        <strong>Privacy Policy for My Website</strong>
      </h1>
      <p>
        
      </p>
      <p>
        My Website one of our main priorities is the privacy of our visitors.
        This Privacy Policy document contains types of information that is
        collected and recorded by My Website and how we use it.
      </p>
      <p>
        
      </p>
      <p>
        If you have additional questions or require more information about our
        Privacy Policy, do not hesitate to contact us.
      </p>
      <p>
        
      </p>
      <p>
        This privacy policy applies only to our online activities and is valid
        for visitors to our website with regards to the information that they
        shared and/or collect in&My Website. This policy is not applicable to
        any information collected offline or via channels other than this
        website.
      </p>
      <h4><strong>Consent</strong></h4>
      <p>
        
      </p>
      <p>
        By using our website, you hereby consent to our Privacy Policy and agree
        to its terms. This Privacy Policy has been generated with the{" "}
        <Link to="https://www.privacypolicygenerator.info/">
          <span class="s1">Privacy Policy Generator</span>
        </Link>{" "} <br />
        which is available from{" "}
        <Link to="https://www.privacypolicygenerator.info/">
          <span class="s1">https://www.privacypolicygenerator.info/</span>
        </Link> <br />
        <Link to="www.https://odishanetacademy.in//">
          <span class="s1">www.https://odishanetacademy.in///</span>
        </Link>
        <span class="Apple-converted-space">&</span>
      </p>
      <p>
        
      </p>
      <h4>
        <strong>Information we collect</strong>
      </h4>
      <p>
        
      </p>
      <p>
        The personal information that you are asked to provide, and the reasons
        why you are asked to provide it, will be made clear to you at the point
        we ask you to provide your personal information.
      </p>
      <p>
        
      </p>
      <p>
        If you contact us directly, we may receive additional information about
        you such as your name, email address, phone number, the contents of the
        message and/or attachments you may send us, and any other information
        you may choose to provide.
      </p>
      <p>
        
      </p>
      <p>
        When you register for an Account, we may ask for your contact
        information, including items such as name, company name, address, email
        address, and telephone number.
      </p>
      <p>
        
      </p>
      <h4>
        <strong>How we use your information</strong>
      </h4>
      <p>
        
      </p>
      <p>We use the information we collect in various ways, including to:</p>
      <p>
        
      </p>
      <ul>
        <li>Provide, operate, and maintain our website</li>
        <li>Improve, personalize, and expand our website</li>
        <li>Understand and analyze how you use our website</li>
        <li>Develop new products, services, features, and functionality</li>
        <li>
          Communicate with you, either directly or through one of our partners,
          including for customer service, to provide you with updates and other
          information relating to the website, and for marketing and promotional
          purposes
        </li>
        <li>Send you emails</li>
        <li>Find and prevent fraud</li>
        <li>Log Files</li>
      </ul>
      <p>
        
      </p>
      <p>
        My Website follows a standard procedure of using log files. These files
        log visitors when they visit websites. All hosting companies do this and
        a part of hosting services' analytics. The information collected by log
        files include internet protocol (IP) addresses, br/owser type, Internet
        Service Provider (ISP), date and time stamp, referring/exit pages, and
        possibly the number of clicks. These are not linked to any information
        that is personally identifiable. The purpose of the information is for
        analyzing trends, administering the site, tracking users' movement on
        the website, and gathering demographic information.
      </p>
      <p>
        
      </p>
      <h4>
        <strong>Cookies and Web Beacons</strong>
      </h4>
      <p>
        
      </p>
      <p>
        Like any other website, My Website uses "cookies". These cookies are
        used to store information including visitors' preferences, and the pages
        on the website that the visitor accessed or visited. The information is
        used to optimize the users' experience by customizing our web page
        content based on visitors' br/owser type and/or other information.
      </p>
      <p>
        
      </p>
      <h4>
        <strong>DoubleClick DART Cookie</strong>
      </h4>
      <p>
        
      </p>
      <p>
        Google is one of a third-party vendor on our site. It also uses cookies,
        known as DART cookies, to serve ads to our site visitors based upon
        their visit to www.website.com and other sites on the internet. However,
        visitors may choose to decline the use of DART cookies by visiting the
        Google ad and content network Privacy Policy at the following URL
        &ndash;{" "}
        <Link to="https://policies.google.com/technologies/ads">
          <span class="s1">https://policies.google.com/technologies/ads</span>
        </Link>
        <span class="Apple-converted-space">&</span>
      </p>
      <p>
        
      </p>
      <p>
        Some of advertisers on our site may use cookies and web beacons. Our
        advertising partners are listed below. Each of our advertising partners
        has their own Privacy Policy for their policies on user data. For easier
        access, we hyperlinked to their Privacy Policies below.
      </p>
      <p>
        
      </p>
      <ul>
        <li>
          Google:{" "} <br />
          <Link to="https://policies.google.com/technologies/ads">
            <span class="s1">https://policies.google.com/technologies/</span>
          </Link>
        </li>
      </ul>
      <h4>
        <strong>Advertising Partners Privacy Policies</strong>
      </h4>
      <p>
        
      </p>
      <p>
        You may consult this list to find the Privacy Policy for each of the
        advertising partners of&My Website.
      </p>
      <p>
        
      </p>
      <p>
        Third-party ad servers or ad networks uses technologies like cookies,
        JavaScript, or Web Beacons that are used in their respective
        advertisements and links that appear on&My Website, which are sent
        directly to users' br/owser. They automatically receive your IP address
        when this occurs. These technologies are used to measure the
        effectiveness of their advertising campaigns and/or to personalize the
        advertising content that you see on websites that you visit.
      </p>
      <p>
        
      </p>
      <p>
        Note that My Website has no access to or control over these cookies that
        are used by third-party advertisers.
      </p>
      <p>
        
      </p>
      <h4>
        <strong>Third-Party Privacy Policies</strong>
      </h4>
      <p>
        
      </p>
      <p>
        My Website's Privacy Policy does not apply to other advertisers or
        websites. Thus, we are advising you to consult the respective Privacy
        Policies of these third-party ad servers for more detailed information.
        It may include their practices and instructions about how to opt-out of
        certain options. You may find a complete list of these Privacy Policies
        and their links here: Privacy Policy Links.
      </p>
      <p>
        
      </p>
      <p>
        You can choose to disable cookies through your individual br/owser
        options. To know more detailed information about cookie management with
        specific web br/owsers, it can be found at the br/owsers' respective
        websites.{" "}
        <Link to="https://www.privacypolicygenerator.info/privacy-policy-cookies-clauses/">
          <span class="s1">What Are Cookies?</span>
        </Link>
      </p>
      <p>
        
      </p>
      <h4>
        <strong>
          CCPA Privacy Policy (Do Not Sell My Personal Information)
        </strong>
      </h4>
      <p>
        
      </p>
      <p>
        Under the CCPA, among other rights, California consumers have the right
        to:
      </p>
      <p>
        
      </p>
      <ul>
        <li>
          Request that a business that collects a consumer's personal data
          disclose the categories and specific pieces of personal data that a
          business has collected about consumers.
        </li>
        <li>
          Request that a business delete any personal data about the consumer
          that a business has collected.
        </li>
        <li>
          Request that a business that sells a consumer's personal data, not
          sell the consumer's personal data.
        </li>
      </ul>
      <p>
        
      </p>
      <p>
        If you make a request, we have one month to respond to you. If you would
        like to exercise any of these rights, please contact us.
      </p>
      <p>
        
      </p>
      <h4>
        <strong>GDPR Privacy Policy (Data Protection Rights)</strong>
      </h4>
      <p>
        
      </p>
      <p>
        We would like to make sure you are fully aware of all of your data
        protection rights. Every user is entitled to the following:
      </p>
      <p>
        
      </p>
      <ul>
        <li>
          The right to access &ndash; You have the right to request copies of
          your personal data. We may charge you a small fee for this service.
        </li>
        <li>
          The right to rectification &ndash; You have the right to request that
          we correct any information you believe is inaccurate. You also have
          the right to request that we complete the information you believe is
          incomplete.
        </li>
        <li>
          The right to erasure &ndash; You have the right to request that we
          erase your personal data, under certain conditions.
        </li>
        <li>
          The right to restrict processing &ndash; You have the right to request
          that we restrict the processing of your personal data, under certain
          conditions.
        </li>
        <li>
          The right to object to processing &ndash; You have the right to object
          to our processing of your personal data, under certain conditions.
        </li>
        <li>
          The right to data portability &ndash; You have the right to request
          that we transfer the data that we have collected to another
          organization, or directly to you, under certain conditions.
        </li>
      </ul>
      <p>
        
      </p>
      <p>
        If you make a request, we have one month to respond to you. If you would
        like to exercise any of these rights, please contact us.
      </p>
      <p>
        
      </p>
      <h4>
        <strong>Children's Information</strong>
      </h4>
      <p>
        
      </p>
      <p>
        Another part of our priority is adding protection for children while
        using the internet. We encourage parents and guardians to observe,
        participate in, and/or monitor and guide their online activity.
      </p>
      <p>
        
      </p>
      <p>
        My Website does not knowingly collect any Personal Identifiable
        Information from children under the age of 13. If you think that your
        child provided this kind of information on our website, we strongly
        encourage you to contact us immediately and we will do our best efforts
        to promptly remove such information from our records.
      </p>
      <p>
        
      </p>
      <h4>
        <strong>Questions</strong>
      </h4>
      <p>
        
      </p>
      <p>
        If you have any questions about this Privacy Policy, please contact us.
      </p>
        </div>
    </section>
     
    </>
  );
}

export default Privacypolicy;
